import TaxDocumentList from './TaxDocumentList'

export default TaxDocumentList
